<h2 mat-dialog-title>{{ action === 'add' ? 'Create User Guide' : 'Edit User Guide' }}</h2>

<mat-dialog-content class="editor-content">
    <div *ngIf="loading" class="text-center py-5">
        <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    </div>

    <div *ngIf="!loading">
        <!-- Key and Area fields (add mode only) -->
        <div *ngIf="action === 'add'" class="row mb-3">
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Guide Key</mat-label>
                    <input matInput [(ngModel)]="key" placeholder="e.g. getting-started">
                    <mat-hint>Kebab-case identifier used in URLs</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Area</mat-label>
                    <mat-select [(ngModel)]="area">
                        <mat-option *ngFor="let opt of areaOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Upload button -->
        <div class="mb-3">
            <button mat-stroked-button (click)="fileInput.click()" type="button">
                <mat-icon>upload_file</mat-icon> Upload .md File
            </button>
            <input #fileInput type="file" accept=".md,.markdown,.txt" (change)="onFileSelected($event)" hidden>
        </div>

        <!-- WYSIWYG Editor -->
        <div class="editor-container">
            <quill-editor
                [(ngModel)]="htmlContent"
                [modules]="quillModules"
                [styles]="{ 'min-height': '350px' }"
                placeholder="Write your guide content here..."
                format="html">
            </quill-editor>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!isValid || submitting">
        {{ submitting ? 'Saving...' : 'Save' }}
    </button>
</mat-dialog-actions>
